export const INTERCOM_APP_ID = process.env.VUE_APP_INTERCOM_APP_ID || 'vtipe3ia';
